import FollowButton from '@/components/FollowButton'
import Nip05 from '@/components/Nip05'
import UserAvatar from '@/components/UserAvatar'
import Username from '@/components/Username'
import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'
import { NostrUser } from '@nostr/gadgets/metadata'
import FollowingBadge from './FollowingBadge'
import { useFetchProfile } from '@/hooks/useFetchProfile'

export default function UserItem({
  user,
  hideFollowButton,
  showFollowingBadge = false,
  className
}: {
  user: string | NostrUser
  hideFollowButton?: boolean
  showFollowingBadge?: boolean
  className?: string
}) {
  const { profile } = useFetchProfile(user)

  if (!profile) return null

  return (
    <div className={cn('flex gap-2 items-center h-14', className)}>
      <UserAvatar user={user} className="shrink-0" />
      <div className="w-full overflow-hidden">
        <div className="flex items-center gap-2">
          <Username
            user={user}
            className="font-semibold truncate max-w-full w-fit"
            skeletonClassName="h-4"
          />
          {showFollowingBadge && <FollowingBadge pubkey={profile.pubkey} />}
        </div>
        <Nip05 user={user} />
      </div>
      {!hideFollowButton && <FollowButton pubkey={profile.pubkey} />}
    </div>
  )
}

export function UserItemSkeleton({ hideFollowButton }: { hideFollowButton?: boolean }) {
  return (
    <div className="flex gap-2 items-center h-14">
      <Skeleton className="w-10 h-10 rounded-full shrink-0" />
      <div className="w-full">
        <div className="py-1">
          <Skeleton className="w-16 h-4" />
        </div>
      </div>
      {!hideFollowButton && <Skeleton className="rounded-full min-w-28 h-9" />}
    </div>
  )
}
